export const SpeechToTextStatus = {
  Connecting: 'connecting',
  Idle: 'idle',
  Ready: 'ready',
  Recording: 'recording',
  Stopping: 'stopping',
}

export const SpeechToTextError = {
  ConfigError: 'speech-to-text-config-error',
  ConnectionError: 'speech-to-text-connection-error',
  MicrophonePermissionDenied: 'microphone-permission-denied',
  MicrophoneUnavailable: 'microphone-unavailable',
  QuotaError: 'speech-to-text-quota-error',
  RecorderUnsupported: 'recorder-unsupported',
  ServiceError: 'speech-to-text-service-error',
  Unknown: 'unknown',
}
